<template>
  <el-dialog
    title="添加应用"
    :visible.sync="visible"
    width="500px"
  >
    <el-form :model="form" :rules="rules" ref="form">
      <el-form-item label="应用ID" prop="appId">
        <el-input v-model="form.appId" placeholder="请输入应用ID"></el-input>
      </el-form-item>
      <el-form-item label="应用名称" prop="appName">
        <el-input v-model="form.appName" placeholder="请输入应用名称"></el-input>
      </el-form-item>
      <el-form-item label="物业" prop="storeId">
        <el-select v-model="form.storeId" placeholder="请选择物业" style="width: 100%" @change="handleStoreChange">
          <el-option v-for="item in merchants" :key="item.storeId" :label="item.name" :value="item.storeId"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="状态" prop="status">
        <el-select v-model="form.status" placeholder="请选择状态">
          <el-option label="启用" value="1"></el-option>
          <el-option label="禁用" value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input type="textarea" v-model="form.remark" placeholder="请输入备注"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="handleSubmit">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { generateAppKey } from '@/api/system/openApiAuthApi'
import { queryMerchant } from '@/api/mall/merchantManageApi'

export default {
  name: 'AddOpenApiApp',
  data() {
    return {
      visible: false,
      merchants: [],
      form: {
        appId: '',
        appName: '',
        storeId: '',
        storeName: '',
        storeAddress: '',
        status: '1',
        remark: ''
      },
      rules: {
        appId: [
          { required: true, message: '请输入应用ID', trigger: 'blur' }
        ],
        appName: [
          { required: true, message: '请输入应用名称', trigger: 'blur' }
        ],
        storeId: [
          { required: true, message: '请选择物业', trigger: 'change' }
        ],
        status: [
          { required: true, message: '请选择状态', trigger: 'change' }
        ]
      }
    }
  },
  created() {
    this._listMerchants()
  },
  methods: {
    async _listMerchants() {
      try {
        const params = {
          page: 1,
          row: 100
        }
        const response = await queryMerchant(params)
        this.merchants = response.data
      } catch (error) {
        console.log('获取商家列表失败', error)
      }
    },
    handleStoreChange(storeId) {
      const merchant = this.merchants.find(item => item.storeId === storeId)
      if (merchant) {
        this.form.storeName = merchant.name || ''
        this.form.storeAddress = merchant.address || merchant.storeAddress || ''
      } else {
        this.form.storeName = ''
        this.form.storeAddress = ''
      }
    },
    open() {
      this.form = {
        appId: '',
        appName: '',
        storeId: '',
        storeName: '',
        storeAddress: '',
        status: '1',
        remark: ''
      }
      this.visible = true
    },
    async handleSubmit() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          try {
            const response = await generateAppKey(this.form)
            if (response.code === 200) {
              this.$message.success('添加成功')
              this.$emit('success', response.data)
              this.visible = false
            } else {
              this.$message.error(response.msg || '添加失败')
            }
          } catch (error) {
            this.$message.error('添加失败')
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>